module.exports = __webpack_public_path__ + "media/images/lp_consultation/access-icon01-055be224d577ae5e6b1fa0c1c11dd012.png";